export const onServiceWorkerUpdateReady = () => {
  if (!window?.location) return;

  window.location.reload();
};

export const onClientEntry = () => {
  window.addEventListener('beforeinstallprompt', e => {
    // Prevents the default mini-infobar or install prompt from showing
    e.preventDefault();
    return false;
  });
};
